import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import BackgroundFileAddRequest from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileAddRequest';
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import ChangeSortIndexNewRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexNewRequest';
import UpdateBackgroundMixRequest from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/UpdateBackgroundMixRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import BackgroundFileGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileGetDetailResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import BackgroundFilesGetListResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse';
import BackgroundMixResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundMixResponse';
import BackgroundFileResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileResponse';

export default class BackgroundFileService {
	webApiService: WebApiService;
	AddEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<BackgroundFileGetDetailResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<BackgroundFilesGetListResponse>>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	GetMixesEvent = new Events<WsResponseModelT<PaginationResponseT<BackgroundMixResponse>>>();
	GetMixDetailsEvent = new Events<WsResponseModelT<BackgroundMixResponse>>();
	UpdateMixEvent = new Events<WsResponseModelT<Boolean>>();
	ChangeMixSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteMixEvent = new Events<WsResponseModelT<Boolean>>();
	GetBackgroundFilesEvent = new Events<WsResponseModelT<Array<BackgroundFileResponse>>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('BackgroundFileService', 'Add', (res: WsResponseModelT<Boolean>) => {
			self.AddEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'GetDetail', (res: WsResponseModelT<BackgroundFileGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'GetList', (res: WsResponseModelT<PaginationResponseT<BackgroundFilesGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'GetMixes', (res: WsResponseModelT<PaginationResponseT<BackgroundMixResponse>>) => {
			self.GetMixesEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'GetMixDetails', (res: WsResponseModelT<BackgroundMixResponse>) => {
			self.GetMixDetailsEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'UpdateMix', (res: WsResponseModelT<Boolean>) => {
			self.UpdateMixEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'ChangeMixSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeMixSortIndexEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'DeleteMix', (res: WsResponseModelT<Boolean>) => {
			self.DeleteMixEvent.trigger(res);
		});
		webApiService.on('BackgroundFileService', 'GetBackgroundFiles', (res: WsResponseModelT<Array<BackgroundFileResponse>>) => {
			self.GetBackgroundFilesEvent.trigger(res);
		});
	}
	Add(request: BackgroundFileAddRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'Add' , request);
    }
	Delete(id: string = '') { 	
        this.webApiService.send('BackgroundFileService', 'Delete' , id);
    }
	GetDetail(id: string = '') { 	
        this.webApiService.send('BackgroundFileService', 'GetDetail' , id);
    }
	GetList(request: FilterRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'GetList' , request);
    }
	ChangeSortIndex(request: ChangeSortIndexNewRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'ChangeSortIndex' , request);
    }
	GetMixes(request: FilterRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'GetMixes' , request);
    }
	GetMixDetails(id: number = 0) { 	
        this.webApiService.send('BackgroundFileService', 'GetMixDetails' , id);
    }
	UpdateMix(request: UpdateBackgroundMixRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'UpdateMix' , request);
    }
	ChangeMixSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('BackgroundFileService', 'ChangeMixSortIndex' , request);
    }
	DeleteMix(id: number = 0) { 	
        this.webApiService.send('BackgroundFileService', 'DeleteMix' , id);
    }
	GetBackgroundFiles() { 	
        this.webApiService.send('BackgroundFileService', 'GetBackgroundFiles' );
    }
	 // async methods
	async addAsync(request: BackgroundFileAddRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Add.bind(this), this.AddEvent)(request);
	}
	async deleteAsync(id: string = ''): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getDetailAsync(id: string = ''): Promise<BackgroundFileGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
	async getListAsync(request: FilterRequest = null): Promise<PaginationResponseT<BackgroundFilesGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async changeSortIndexAsync(request: ChangeSortIndexNewRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
	async getMixesAsync(request: FilterRequest = null): Promise<PaginationResponseT<BackgroundMixResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetMixes.bind(this), this.GetMixesEvent)(request);
	}
	async getMixDetailsAsync(id: number = 0): Promise<BackgroundMixResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetMixDetails.bind(this), this.GetMixDetailsEvent)(id);
	}
	async updateMixAsync(request: UpdateBackgroundMixRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateMix.bind(this), this.UpdateMixEvent)(request);
	}
	async changeMixSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeMixSortIndex.bind(this), this.ChangeMixSortIndexEvent)(request);
	}
	async deleteMixAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteMix.bind(this), this.DeleteMixEvent)(id);
	}
	async getBackgroundFilesAsync(): Promise<Array<BackgroundFileResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetBackgroundFiles.bind(this), this.GetBackgroundFilesEvent)();
	}
}